import React from 'react';
import t from 'react-translate';
import { CloneMentorshipProgramWizardStep } from './state/types';

const getTranslationDataByStep = (step: CloneMentorshipProgramWizardStep) => {
  const translations = {
    [CloneMentorshipProgramWizardStep.CONFIG]: {
      title: t.MENTORING_PROGRAMS.PROGRAM_HEADER_MENU.CLONE.STEPS.STEP_ONE.TITLE(),
      description: t.MENTORING_PROGRAMS.PROGRAM_HEADER_MENU.CLONE.STEPS.STEP_ONE.DESCRIPTION(),
    },
    [CloneMentorshipProgramWizardStep.ADMIN_REVIEW]: {
      title: t.MENTORING_PROGRAMS.PROGRAM_HEADER_MENU.CLONE.STEPS.STEP_TWO.TITLE(),
      description: t.MENTORING_PROGRAMS.PROGRAM_HEADER_MENU.CLONE.STEPS.STEP_TWO.DESCRIPTION(),
    },
    [CloneMentorshipProgramWizardStep.REVIEW]: {
      title: t.MENTORING_PROGRAMS.PROGRAM_HEADER_MENU.CLONE.STEPS.STEP_THREE.TITLE(),
      description: t.MENTORING_PROGRAMS.PROGRAM_HEADER_MENU.CLONE.STEPS.STEP_THREE.DESCRIPTION(),
    },
  };

  return translations[step] || {
    title: '',
    description: '',
  };
};

type CloneMentorshipProgramModalHeaderProps = {
  step: CloneMentorshipProgramWizardStep;
};

const CloneMentorshipProgramModalHeader = ({
  step,
}: CloneMentorshipProgramModalHeaderProps) => {
  const { title, description } = getTranslationDataByStep(step);

  return (
    <div className='header-section mb-4'>
      <div className='title course-title-regular'>
        {title}
      </div>
      <div className='text-regular text-gray-2'>
        {description}
      </div>
    </div>
  );
};

export default CloneMentorshipProgramModalHeader;
